export enum ProductTileType {
  SEARCH = "SEARCH",
  BRAND = "BRAND",
  SDUI_EVALUATE = "SDUI_EVALUATE",
  LAYOUT_ELEMENT = "LAYOUT_ELEMENT",
}
